import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  declare titleTarget: HTMLInputElement
  declare submitTarget: HTMLButtonElement

  static targets = ["title", "submit"]

  connect() {
    this.validate()
  }

  validate() {
    this.submitTarget.disabled = this.titleTarget.value.trim() === ""
  }
}
